/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const signatureType = {
  athletics: {
    src: "yhc-athletics-logo.png",
    alt: "91TV Athletics Logo",
    type: "91TV Athletics",
    address: "1 College Street, Young Harris, GA 30582",
    url: "https://yhcathletics.com/",
    urlDisplay: "yhcathletics.com",
  },
  facultyStaff: {
    src: "yhc-faculty-staff-logo.png",
    alt: "91TV Logo",
    type: "91TV",
    address: "1 College Street, Young Harris, GA 30582",
    url: "/",
    urlDisplay: "yhc.edu",
  },
};

function customizeEmailSignature(e) {
	if (document.getElementById("email-signature-form").checkValidity()) {
		e.preventDefault();
		var tabledata = document.querySelectorAll(".table-data");
    var tableDataReply = document.querySelectorAll(".table-data-reply");
    var tableDataStatic = document.querySelectorAll(".table-data-static");
		var formdata = document.querySelectorAll(
			'#email-signature-form select, #email-signature-form input:not([type="submit"]):not([type="button"])'
		);
		for (var i = 0; i < tabledata.length; i++) {
      if (formdata[i]) {
        if (formdata[i].nodeName === "SELECT") {
          var ind = tabledata[i].src.lastIndexOf('/');
          tabledata[i].src = tabledata[i].src.substring(0, ind+1) + signatureType[formdata[i].value].src;
          tabledata[i].alt = signatureType[formdata[i].value].alt;
          tableDataStatic[0].innerText = signatureType[formdata[i].value].type;
          tableDataStatic[1].innerText = signatureType[formdata[i].value].address;
          tableDataStatic[2].href = signatureType[formdata[i].value].url;
          tableDataStatic[2].innerText = signatureType[formdata[i].value].urlDisplay;
          const athleticsBottomLogo = document.querySelector("#email-signature .athletics-bottom-logo");
          if (formdata[i].value == 'athletics') {
            if (!athleticsBottomLogo) {
              document.querySelector("#email-signature td:last-child table tbody").appendChild(athleticsImg);
            }
          } else if (athleticsBottomLogo) {
            athleticsBottomLogo.remove();
          }
        } else if (formdata[i].getAttribute("type") === "tel") {
          var telephone = formdata[i].value.split("-");
          tabledata[i].innerText =
              telephone[0] + "." + telephone[1] + "." + telephone[2];
          tabledata[i].href = "tel:" + formdata[i].value;
          tableDataReply[tableDataReply.length - 1].innerText =
              telephone[0] + "." + telephone[1] + "." + telephone[2];
          tableDataReply[tableDataReply.length - 1].href = "tel:" + formdata[i].value;
        } else if (formdata[i].getAttribute("type") === "email") {
          tabledata[i].href = "mailto:" + formdata[i].value;
          tabledata[i].innerText = formdata[i].value;
        } else {
          tabledata[i].innerText = formdata[i].value;
          if (typeof tableDataReply[i - 1] !== 'undefined') {
              tableDataReply[i - 1].innerText = formdata[i].value;
          }
        }
      }
    }
	}
}
document
	.getElementById("signature-customize")
	.addEventListener("click", customizeEmailSignature);

const athleticsImg = document
	.querySelector("#email-signature .athletics-bottom-logo")
  .cloneNode(true);

function selectEmailTable(el) {
  var body = document.body,
    range,
    sel;
  if (document.createRange && window.getSelection) {
    range = document.createRange();
    sel = window.getSelection();
    sel.removeAllRanges();
    try {
      range.selectNodeContents(el);
      sel.addRange(range);
    } catch (e) {
      range.selectNode(el);
      sel.addRange(range);
    }
    document.execCommand("copy");
  } else if (body.createTextRange) {
    range = body.createTextRange();
    range.moveToElementText(el);
    range.select();
    range.execCommand("Copy");
  }
}
document
  .querySelector(".email-signature-button")
  .addEventListener("click", function () {
    selectEmailTable(document.getElementById("email-signature"));
  });
document
  .querySelector(".email-signature-reply-button")
  .addEventListener("click", function () {
    selectEmailTable(document.getElementById("email-signature-reply"));
  });

window.addEventListener('load', () => {
  const phoneInput = document.querySelector('#emailsig-ophone');
  phoneInput.addEventListener('input', formatToPhone);
});

const formatToPhone = (evt) => {
  const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
  const areaCode = digits.substring(0,3);
  const prefix = digits.substring(3,6);
  const suffix = digits.substring(6,10);

  if(digits.length > 6) {evt.target.value = `${areaCode}-${prefix}-${suffix}`;}
  else if(digits.length > 3) {evt.target.value = `${areaCode}-${prefix}`;}
  else if(digits.length > 0) {evt.target.value = `${areaCode}`;}
  else {evt.target.value = ``;}
};
